import {DokumentVersjonModell, VirussjekkStatus} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {erArkivdokument} from "felles-ng2/modell/dokumentModellHjelpere";
import {i18n, Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import {Dialog} from "felles-ng2/tjenester/Dialog";
import {DokumentFormatInfo, DokumentInformasjonTjeneste} from "felles-ng2/tjenester/DokumentInformasjonTjeneste";
import {mimetyper} from "felles-ng2/støttefunksjoner/mimetyper";
import {åpneINyttvindu} from "felles-ng2/støttefunksjoner/nettleser";
import {Injectable} from "@angular/core";
import {KlientKapasiteter} from "felles-ng2/tjenester/KlientKapasiteter";
import {SaksdokumentDatatjeneste} from "felles-ng2/tjenester/datalager/SaksdokumentDatatjeneste";
import {ArkivDatatjeneste} from "felles-ng2/tjenester/datalager/ArkivDatatjeneste";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";

const debug = initDebugger('DokumentTjeneste');

/** Tjeneste for åpning av dokument i nettleser */
@Injectable({providedIn: 'root'})
export class ÅpneDokumentTjeneste {

    constructor(
      private oversettelser: Oversettelser,
      private dialog: Dialog,
      private saksdokumentDatatjeneste: SaksdokumentDatatjeneste,
      private arkivDatatjeneste: ArkivDatatjeneste,
      private dokumentInformasjon: DokumentInformasjonTjeneste,
      private klientKapasiteter: KlientKapasiteter) {
    }

    /** Åpner dokumentet i ny arkfane. Dersom dokumentet er et PDF-dokument viser vi det i vår PDFjs baserte pdf-vier. */
    async åpne(dokumentversjon: DokumentVersjonModell, format: DokumentFormatInfo, åpneIPdfjs = true): Promise<void> {
        if (dokumentversjon.virussjekkStatus == VirussjekkStatus.infisert) {
            await this.dialog.advarsel({
                tittel: this.oversettelser.oversett(i18n('Åpning av dokument forhindret')),
                innhold: this.oversettelser.oversett(i18n('Dokumentet er virusinfisert og kan derfor ikke åpnes'))
            })
            return;
        }

        if (!dokumentversjon.erLestAv) this.markerDokumentSomLest(dokumentversjon);

        if (åpneIPdfjs && this.klientKapasiteter.støtterPdfjs()) {
            if (format.mimeinfo.mimetype === mimetyper.pdf.mimetype) {
                this.åpneIPdfjs(dokumentversjon);
                return;
            } else
                debug('kan ikke åpne ikke-pdf med pdfjs', format.mimeinfo.mimetype, format.url);
        }

        åpneINyttvindu(format.url);
    }

    /** Markerer dokumentet som lest i datalager.
     * Merk at dokumentet blir markert som lest på serversiden som sideeffekt av at dokumentet hentes, derfor gjøres ikke noe serverkall her,
     * kun oppdatering i lokalt datalager.
     * Forutsetter med andre ord at kaller av denne metoden også sørger for at dokumentet blir åpnet og derigjennom blir markert som lest på serverside. */
    markerDokumentSomLest(dokumentversjon: DokumentVersjonModell): void {
        erArkivdokument(dokumentversjon) ?
          this.arkivDatatjeneste.markerSomLestILokallager(dokumentversjon.dokumentId) :
          this.saksdokumentDatatjeneste.markerSomLestILokallager(dokumentversjon.dokumentId);
    }

    //hjelpemetoder

    private åpneIPdfjs(dokumentversjon: DokumentVersjonModell) {
        const informasjon = this.dokumentInformasjon.dokumentinformasjon(dokumentversjon);

        debug('åpner med pdfjs', informasjon.pdfjsDokumentViserUrl);
        åpneINyttvindu(informasjon.pdfjsDokumentViserUrl);
    }

}
